var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".labelIconA{fill:currentColor;}.labelIconB{fill:#fff;stroke:#fff;}.labelIconC{stroke:none;}.labelIconD{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-97 -259)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "labelIconA",
    width: 15,
    height: 9,
    rx: 1,
    transform: "translate(97 259)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "labelIconB",
    transform: "translate(99 262)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "labelIconC",
    width: 11,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "labelIconD",
    x: 0.5,
    y: 0.5,
    width: 10
  })), /*#__PURE__*/React.createElement("g", {
    className: "labelIconB",
    transform: "translate(99 264)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "labelIconC",
    width: 8,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "labelIconD",
    x: 0.5,
    y: 0.5,
    width: 7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/Label.f9d3f67b.svg";
export { ForwardRef as ReactComponent };